import moment from 'moment'

export default function tarihFormat(tarih: moment.MomentInput) {
  if(!tarih) {
    return ''
  }
  return moment(tarih).locale('tr').format('DD.MM.YYYY')
}

export function tarihSaatFormat(tarih: moment.MomentInput) {
  if(!tarih) {
    return ''
  }
  return moment(tarih).format('DD/MM/YYYY HH:mm')
}

export function saatFormat(saat: moment.MomentInput) {
  if(!saat) {
    return ''
  }
  return moment(saat).format('HH:mm:ss')
}

export function saniyeFormat(saniye: number | undefined) {
  if (!saniye) {
    return ''
  }
  const duration = moment.duration(saniye, 'seconds')
  const dakika = Math.floor(duration.asMinutes())
  const saniyeler = duration.seconds()
  const salise = Math.floor(duration.milliseconds() / 10)

  const parts = []
  if (dakika > 0) parts.push(`${dakika}dk`)
  if (saniyeler > 0) parts.push(`${saniyeler}sn`)
  if (salise > 0) parts.push(`${salise} salise`)

  return parts.join(' ')
}
